
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class RateFixingDialog extends _Ext.TransDialog<RateFixingRow, any> {

        protected getFormKey() { return RateFixingForm.formKey; }
        protected getIdProperty() { return RateFixingRow.idProperty; }
        protected getLocalTextPrefix() { return RateFixingRow.localTextPrefix; }
        protected getNameProperty() { return RateFixingRow.nameProperty; }
        protected getService() { return RateFixingService.baseUrl; }
        protected getDeletePermission() { return RateFixingRow.deletePermission; }
        protected getInsertPermission() { return RateFixingRow.insertPermission; }
        protected getUpdatePermission() { return RateFixingRow.updatePermission; }

        public form = new RateFixingForm(this.idPrefix);
        TaxArray: any[];
        TaxRegistred: number;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.hideCaption(this.form.LedgerName);

            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            q.hideEditorTab
            this.form.TaxDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {

                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }

            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }); 
            this.form.Weight.changeSelect2(e => {
                var Rate = parseFloat(this.form.Rate.value.toString());
                this.form.GrossAmount.value = parseFloat(this.form.Weight.value.toString()) * Rate;
            });
            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});



            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;


            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getItems().length;
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                if (Items.length == TotalItems) {

                    this.CalculateAmountandTax(Items, TotalItems);
                }
            });
            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.VendorGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Supplier"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {

                this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                this.form.LedgerName.value = selectedItems[0].LedgerName;

                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.LedgerName.value = selectedItems[0].LedgerName;
                this.form.ItemDetails.RateListId = selectedItems[0].CostPricegroupId == null ? 0 : selectedItems[0].CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                this.form.ItemDetails.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                this.form.ItemDetails.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                this.form.GstVat.value = selectedItems[0].GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            }
            pickerDialog.dialogOpen();

        }


        public CalculateAmountandTax(Items: any,  TotalItems: number) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ItemTotal = 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;

                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {

                var TaxItems = this.form.TaxDetails.getItems().length;
                var it = this.form.TaxDetails.getItems();
                if (TaxItems > 0) {
                    this.form.TaxDetails.DeleteTax();
                }
                //alert(this.form.TaxDetails.getItems().length);
                for (let i = 0; i < codearray.length; i++) {

                    var Tax = OMS.HsnTaxMasterRow.getLookup().items.filter(x => x.Code == codearray[i] && x.TaxGroup == Q.Authorization.userDefinition.TaxGroupId)[0];

                    var TaxRate: number;
                    var Tax1Rate: number;
                    var Tax2Rate: number;

                    var netamt = parseInt(amtarray[i].toString());
                    let partystate = this.form.State.value;
                    var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;
                    if (partystate == Cmpstate) {
                        Tax.TaxId = 0;
                        TaxRate = 0;
                        Tax1Rate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.Tax1Id && x.Date <= this.form.TransDate.value)[0].Rate
                        Tax2Rate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.Tax2Id && x.Date <= this.form.TransDate.value)[0].Rate

                        var TaxRow: RateFixingTaxRow = {
                            HSN: codearray[i],
                            NetAmount: netamt,
                            TaxId: 0,
                            TaxRate: 0,
                            TaxAmount: 0,
                            CessId: 0,
                            CessAmount: 0,
                            CessRate: 0,
                            TaxLedgerId: Tax.TaxLedgerId,
                            CessLedgerId: Tax.CessLedgerId,

                        }
                        TaxDetail.push(TaxRow)
                        var cols = this.form.TaxDetails.slickGrid.getColumns();
                        var cols = cols.filter(x => x.field != "TaxId" && x.field != "TaxRate" && x.field != "TaxAmount");
                        this.form.TaxDetails.slickGrid.setColumns(cols);

                    }
                    else {
                        TaxRate = OMS.TaxRateHistoryRow.getLookup().items.filter(x => x.TaxId == Tax.TaxId && x.Date <= this.form.TransDate.value)[0].Rate
                        var TaxRow: RateFixingTaxRow = {
                            TaxId: Tax.TaxId,
                            HSN: codearray[i],
                            NetAmount: netamt,
                            TaxRate: TaxRate,
                            TaxAmount: netamt * (TaxRate / 100),

                            CessId: 0,
                            CessAmount: 0,
                            CessRate: 0,
                            TaxLedgerId: Tax.TaxLedgerId,
                            CessLedgerId: Tax.CessLedgerId,

                        }

                        TaxDetail.push(TaxRow)

                        var cols = this.form.TaxDetails.slickGrid.getColumns();
                        var cols = cols.filter(x => x.field != "Tax1Id" && x.field != "Tax1Rate" && x.field != "Tax1Amount" && x.field != "Tax2Id" && x.field != "Tax2Rate" && x.field != "Tax2Amount");
                        this.form.TaxDetails.slickGrid.setColumns(cols);

                    }

                }
                var temp2 = this.form.TaxDetails.getData(TaxDetail);
                this.form.TaxDetails.view.setItems(temp2, true);


                TaxDetail.forEach(function (value) {

                    TaxAmount += value.TaxAmount + value.Tax1Amount + value.Tax2Amount + value.CessAmount + value.Cess1Amount + value.Cess2Amount;

                });

                this.form.TaxAmount.value = TaxAmount;
                this.form.GrossAmount.value = gramt + TaxAmount;
            }
            else {
                this.form.GrossAmount.value = gramt;

            }


        }
        protected onDialogOpen() {
            super.onDialogOpen()

            if (this.form.PartyId.value != "") {
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            } else {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            //btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'RateFixing.RateFixing',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            var postingpermission = Q.Authorization.hasPermission('Purchase:RateFixing:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'fa-upload',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;

                    RateFixingService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });


            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                RateFixingService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
         
    }
}